import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPreparatPharmacy } from '@interfaces';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';

@Component({
  selector: 'bz-pharmacy-info',
  templateUrl: './bz-pharmacy-info.component.html',
  styleUrls: ['./bz-pharmacy-info.component.sass']
})
export class BzPharmacyInfoComponent {

  @Input() public exists: IPreparatPharmacy[] = [];

  @Output() public onTogglePharmacy: EventEmitter<IPreparatPharmacy> = new EventEmitter();

  trackById = (_: unknown, item: IPreparatPharmacy) => item.id;

  readonly imgPath!: string;

  constructor(
    private readonly restUrlService: RestUrlService
  ) {
    this.imgPath = this.restUrlService.getUrl(TypeUrl.img) + '/';
  }

  public togglePharmacy(pharmacy: IPreparatPharmacy): void {
    this.onTogglePharmacy.emit(pharmacy);
  }

}
